import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Debug logs dump API responses, RUTs and payloads; keep them out of production consoles.
// ponytail: also silences the MFE (same window); a real logger would let warn/error carry a trace id.
if (environment.production) {
  console.log = console.info = console.debug = () => {};
}

// Fail-closed: without Initialize there are no roles, so the app must not render; show why instead of a blank page.
bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error(err);
  document.querySelector('app-root')!.innerHTML = `
    <div role="alert" class="min-h-screen flex flex-col items-center justify-center gap-3 text-center p-6">
      <p class="text-lg font-semibold text-gray-900">No pudimos cargar Registro</p>
      <p class="text-sm text-gray-600">Un servicio no respondió. Inténtalo de nuevo en unos minutos.</p>
      <button type="button" class="mt-2 px-4 py-2 rounded-md bg-primary text-white text-sm">Reintentar</button>
    </div>`;
  document.querySelector('app-root button')!.addEventListener('click', () => location.reload());
});
